<template>
  <!-- 模版页面 -->
  <div class="test-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button style="margin-right: 20px" size="small" type="primary" @click="openDialog(1)">价格配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.type" placeholder="请选择类型" @change="getData()">
            <el-option :value="1" label="普通盒子"></el-option>
            <el-option :value="2" label="热血盲盒"></el-option>
            <el-option :value="3" label="商城"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData()">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="type" label="类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">普通盒子</span>
            <span v-if="row.type == 2">热血盲盒</span>
            <span v-if="row.type == 3">商城</span>
          </template>
        </el-table-column>
        <el-table-column prop="min_price" label="最低价格" align="center" sortable>
        </el-table-column>
        <el-table-column prop="max_price" label="最高价格" align="center" sortable>
        </el-table-column>
        <el-table-column prop="lowest_nums" label="最低个数" align="center">
        </el-table-column>
        <el-table-column prop="premium_rate" label="溢价率" align="center">
        </el-table-column>
        <el-table-column prop="premium_rate" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status">开启</el-tag>
            <el-tag type="danger" v-else>关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-col class="col-box" :span="30">
              <el-button size="small" type="primary" @click="openDialog(2, row)">编辑</el-button>
              <!-- <el-button size="small" type="danger" @click="deleteHandle(row)">删除</el-button> -->
            </el-col>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <!-- 价格配置弹窗 -->
    <ConfigDialog :visible="configVisible" :typeDialog="dialogType" v-model="dialogInfos" @refresh="getData"
      @close="configVisible = false">
    </ConfigDialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import ConfigDialog from './component/ConfigDialog.vue'
export default {
  components: {
    ConfigDialog
  },
  data() {
    return {
      configVisible: false,//价格配置弹窗显示标志
      loading: false,//加载动画
      query: {
        page: 1,
        type: 1, //1是普通盒子 2是热血盲盒 3是商城
      },
      dialogType: 0,//类型 1是添加 2是编辑
      dialogInfos: undefined,//弹窗数据
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.query.type) {
        this.$message.error("请选择类型")
        return
      }
      this.loading = true
      let params = this.query
      getApiData('goods_premium', params).then(res => {
        if (res) {
          this.dataList = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    //打开编辑弹窗
    openDialog(num, rowInfos) {
      this.configVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(rowInfos))
      }
    },
    //删除
    deleteHandle(row) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delData().then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {}

  .body-box {
    // width: 800px;
  }
}
</style>